import React from"react";var emojiComponent=function(props){return React.createElement("span",{style:{fontFamily:"cursive"}},props.children)};export{emojiComponent};
//# sourceMappingURL=emojiComponent.js.map
